import { rem } from 'polished';
import styled from 'styled-components';
import Spinner from '@molecules/Spinner/Spinner';

export const StyledSearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};

  padding: 0 ${rem(20)} ${rem(20)} ${rem(20)};
`;

export const StyledSpinner = styled(Spinner)`
  margin: ${rem(20)};
`;
